"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolNative = void 0;
var core_1 = require("@moralisweb3/core");
var unitToDecimals = {
    solana: 9,
    lamports: 0,
};
var SolNative = /** @class */ (function () {
    function SolNative(rawValue) {
        this.rawValue = rawValue;
    }
    SolNative.create = function (value, unit) {
        if (value instanceof SolNative) {
            return value;
        }
        return new SolNative(SolNative.parse(value, unit));
    };
    SolNative.parse = function (value, unit) {
        if (unit === void 0) { unit = 'solana'; }
        var decimal;
        if (typeof unit === 'number') {
            decimal = unit;
        }
        else if (unitToDecimals[unit] !== undefined) {
            decimal = unitToDecimals[unit];
        }
        else {
            throw new core_1.MoralisCoreError({
                code: core_1.CoreErrorCode.INVALID_ARGUMENT,
                message: "Not supported Solana unit: ".concat(unit),
            });
        }
        return core_1.BigNumber.fromDecimal(value.toString(), decimal);
    };
    Object.defineProperty(SolNative.prototype, "value", {
        get: function () {
            return this.rawValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolNative.prototype, "solana", {
        get: function () {
            return this.rawValue.toDecimal(unitToDecimals['solana']);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolNative.prototype, "lamports", {
        get: function () {
            return this.rawValue.toString();
        },
        enumerable: false,
        configurable: true
    });
    SolNative.prototype.format = function () {
        // TODO: add `format` argument
        return this.lamports;
    };
    SolNative.prototype.equals = function (value) {
        return this.lamports === value.lamports;
    };
    SolNative.prototype.toJSON = function () {
        return this.lamports;
    };
    SolNative.prototype.toString = function () {
        return this.lamports;
    };
    return SolNative;
}());
exports.SolNative = SolNative;
//# sourceMappingURL=SolNative.js.map